import React from 'react'
import { RingProgress, Text, SimpleGrid, Paper, Center, Group, rem } from '@mantine/core';
import { IconArrowUpRight, IconArrowDownRight } from '@tabler/icons-react';


const icons = {
    up: IconArrowUpRight,
    down: IconArrowDownRight,
};
function StatsCard({ stat }) {
    const Icon = icons[stat.icon];

    return (
        <Paper withBorder radius="md" p="xs" key={stat.label}>
            <Group>
                {/* <RingProgress
        size={80}
        roundCaps
        thickness={8}
        sections={[{ value: stat.progress, color: stat.color }]}
        label={
          <Center>
            <Icon style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
          </Center>
        }
      /> */}

                <div>
                    <Text c="dimmed" size="xs" fw={600}>
                        {stat.label}
                    </Text>
                    <Text fw={500} size="s">
                        {stat.stats ?? "N/A"}
                    </Text>
                </div>
            </Group>
        </Paper>)
}

export default StatsCard
